module.exports = __webpack_public_path__ + "c2883e33d72e50e2775eb220ab04fdd4.svg";